import Box from '@mui/material/Box';
import Form from 'components/form';
import DateInput from 'components/form/DatePicker';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const DateField = ({ id, required, inputProps }) => {
  const { getFieldDecorator } = useForm();

  return (
    <Box display="flex" justifyContent="center">
      <FormItem>
        {getFieldDecorator(id, {
          rules: [{ required, message: 'Please select a valid date' }],
          normalize: (value) => {
            if (value && value._isAMomentObject) {
              return value.format('YYYY-MM-DD');
            }
            return value;
          },
        })(
          <DateInput
            fullWidth
            margin="dense"
            placeholder="MM/DD/YYYY"
            autoFocus={inputProps?.autoFocus}
            sx={{
              '& .MuiInputAdornment-positionEnd': {
                position: 'absolute',
                right: 16,
              },
            }}
          />,
        )}
      </FormItem>
    </Box>
  );
};

export default DateField;
